import { readCookie, setCookie } from './main.js';


$(document).ready(function () {
  var $captador = $('#captador'),
    $formDownloadVideoButton = $('form.download-video .button'),
    $formIntegrationsButton = $('form.integrations .button'),
    $formPartners = $('#form-partners'),
    $formPartnersButton = $('#form-partners .button'),
    $formServices = $('#form-services'),
    $formServicesButton = $('#form-services .button'),
    $formTeam = $('#form-team'),
    $formTeamButton = $('#form-team .button'),
    $formAgencies = $('#form-agencies'),
    $formAgenciesButton = $('#form-agencies .button'),
    $formContact = $('#form-contact'),
    $formContactButton = $('#form-contact .button'),
    $formPlanesMedida = $('#form-plan-a-medida'),
    $formPlanesMedidaButton = $('#form-plan-a-medida .button'),
    $formSuggestions = $('#form-suggestions'),
    $formCustomFeatures = $('#form-custom-features'),
    $formCustomFeaturesButton = $('#form-custom-features .button'),
    $formSuggestionsButton = $('#form-suggestions .button'),
    $formAgreement = $('#form-agreement'),
    $modal = $('#modal-video .c-modal__content'),
    $formAgreementButton = $('#form-agreement  .button'),
    $formAgreementAuth = $('#form-agreement-auth'),
    $formAgreementAuthButton = $('#form-agreement-auth  .button'),
    $modalVideoButton = $('figure a.video'),
    $modalVideoImageButton = $('figure a.show-video'),
    $showDownloadButton = $('figure .show-download'),
    $formPartnersLanding = $('#form-partners-landing'),
    $formPartnersLandingButton = $('#form-partners-landing .button');

  $formDownloadVideoButton.on('click', function (event) {
    event.preventDefault();
    var $form = $(this).closest('form'),
      $activeCookies = true,
      $email = $form.find('input[type=email]'),
      $aceptoPoliticas = $form
        .find('input[name=acepto_politicas]')
        .is(':checked'),
      $aceptoPromociones = $form
        .find('input[name=acepto_promociones]')
        .is(':checked'),
      $url = $form.attr('data-video');

    if (
      typeof OnetrustActiveGroups != 'undefined' &&
      (!OnetrustActiveGroups.includes('C0003') ||
        !OnetrustActiveGroups.includes('C0004'))
    ) {
      // Functional and targeting and  Cookies
      $form.find('.cookies-message--advice').fadeOut(function () {
        $form.find('.cookies-message--error').fadeIn();
      });
      $activeCookies = false;
    }

    if (validateForm($form) && $activeCookies) {
      var data = {
        email: $email.val(),
        list_id: $form.attr('data-list-id'),
        acepto_politicas: $aceptoPoliticas,
        acepto_promociones: $aceptoPromociones,
      };
      sentDataBackend(data, 'subscriber', 'resources', $form);
      setFunctionalityCookies(
        $email.val(),
        $aceptoPoliticas,
        $aceptoPromociones,
      );

      $('figure.open').removeClass('open').addClass('active');
      $('a.video').html('Reproducir el video >>');
    }

    return false;
  });

  $formIntegrationsButton.on('click', function () {
    var $form = $(this).closest('form'),
      $email = $form.find('input[type=email]'),
      nombre = $form.find('input[name=name-input]').val(),
      apellido = $form.find('input[name=lastname-input]').val(),
      aceptoPoliticas = $form
        .find('input[name=acepto_politicas]')
        .is(':checked'),
      aceptoPromociones = $form
        .find('input[name=acepto_promociones]')
        .is(':checked'),
      integrationName = $form.closest('footer').find('p strong').html();

    if (validateForm($form)) {
      var data = {
        email: $email.val(),
        list_id: $form.attr('data-list-id'),
        acepto_politicas: aceptoPoliticas,
        acepto_promociones: aceptoPromociones,
        nombre: nombre,
        apellido: apellido,
        integration: integrationName,
      };

      sentDataBackend(data, 'full', 'integration', $form);

      setTimeout(function () {
        $('figure.open').removeClass('open');
        $form[0].reset();
      }, 3000);
    }

    return false;
  });



  $formTeamButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formTeam)) {
      var data = {
        nombre: $formTeam.find('#name-input').val(),
        apellido: $formTeam.find('#lastname-input').val(),
        email: $formTeam.find('#email-input').val(),
        linkedin: $formTeam.find('#web-input').val(),
        comentario: $formTeam.find('#comment-input').val(),
        acepto_politicas: $formTeam
          .find('input[name=acepto_politicas]')
          .is(':checked'),
      };
      sentDataBackend(data, 'sendEmail', 'team', $formTeam);
    }
    return false;
  });

  $formAgenciesButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formAgencies)) {
      var data = {
        nombre: $formAgencies.find('input[name=name-input]').val(),
        apellido: $formAgencies.find('input[name=lastname-input]').val(),
        email: $formAgencies.find('input[name=email-input]').val(),
        telefono:
          $formAgencies.find('.selected-dial-code').text() +
          $formAgencies.find('#phone-input').val(),
        horario: $formAgencies.find('input[name=time-input]').val(),
        acepto_politicas: $formAgencies
          .find('input[name=acepto_politicas]')
          .is(':checked'),
        acepto_promociones: $formAgencies
          .find('input[name=acepto_promociones]')
          .is(':checked'),
      };
      sentDataBackend(data, 'sendEmail', 'agencias', $formAgencies);
    }
    return false;
  });

  $formServicesButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formServices)) {
      var data = {
        nombre: $formServices.find('#name-input').val(),
        apellido: $formServices.find('#lastname-input').val(),
        email: $formServices.find('#email-input').val(),
        telefono:
          $formServices.find('.selected-dial-code').text() +
          $formServices.find('#phone-input').val(),
        horario: $formServices.find('#time-input').val(),
        comentario: $formServices.find('#comment-input').val(),
        acepto_politicas: $formServices
          .find('input[name=acepto_politicas]')
          .is(':checked'),
      };
      sentDataBackend(data, 'sendEmail', 'servicios', $formServices);
    }
    return false;
  });

  $formPartnersButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formPartners)) {
      var email = $formPartners.find('input[type=email]').val(),
        data = {
          nombre: $formPartners.find('input[name=name]').val(),
          apellido: $formPartners.find('input[name=lastname]').val(),
          email: email,
          pais: $formPartners.find('#country-input').val(),
          cod_pais: $formPartners.find('#country-input').attr('data-code'),
          web: $formPartners.find('input[name=web-input]').val(),
          comentario: $formPartners.find('textarea[name=comment-input]').val(),
          acepto_politicas: $formPartners
            .find('input[name=acepto_politicas]')
            .is(':checked'),
        };
      sentDataBackend(data, 'full', 'partners', $formPartners);
    }
    return false;
  });

  $formPartnersLandingButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formPartnersLanding)) {
      var email = $formPartnersLanding.find('input[type=email]').val(),
        data = {
          nombre: $formPartnersLanding.find('input[name=name]').val(),
          apellido: $formPartnersLanding.find('input[name=lastname]').val(),
          email: email,
          telefono:
          $formPartnersLanding.find('.selected-dial-code').text() +
          $formPartnersLanding.find('#phone').val(),
          horario: $formPartnersLanding.find('#time').val(),
          web: $formPartnersLanding.find('input[name=web]').val(),
          empresa: $formPartnersLanding.find('input[name=company]').val(),
          acepto_politicas: $formPartnersLanding
            .find('input[name=acepto_politicas]')
            .is(':checked'),
        };
      $formPartnersLanding.addClass('disabled');
      sentDataBackend(data, 'full', 'partners-landing', $formPartnersLanding);
    }
    return false;
  });

  $formContactButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formContact)) {
      var data = {
        nombre: $formContact.find('input[name=name-input]').val(),
        apellido: $formContact.find('input[name=lastname-input]').val(),
        email: $formContact.find('input[name=email-input]').val(),
        telefono:
          $formContact.find('.selected-dial-code').text() +
          $formContact.find('#phone-input').val(),
        horario: $formContact.find('#time-input').val(),
        motivo: $formContact.find('#web-input').val(),
        comentario: $formContact.find('#comment-input').val(),
        acepto_politicas: $formContact
          .find('input[name=acepto_politicas]')
          .is(':checked'),
      };
      $formContact.addClass('disabled');
      sentDataBackend(data, 'sendEmail', 'contacto', $formContact);
    }

    return false;
  });

  $formPlanesMedidaButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formPlanesMedida)) {
      var data = {
        nombre: $formPlanesMedida.find('#name-input').val(),
        apellido: $formPlanesMedida.find('#lastname-input').val(),
        email: $formPlanesMedida.find('#email-input').val(),
        telefono:
          $formPlanesMedida.find('.selected-dial-code').text() +
          $formPlanesMedida.find('#phone-input').val(),
        horario: $formPlanesMedida.find('#time-input').val(),
        volumen_envios: $formPlanesMedida
          .find('input[name=shipping]:checked')
          .attr('data-value'),
        acepto_politicas: $formPlanesMedida
          .find('input[name=acepto_politicas]')
          .is(':checked'),
      };
      sentDataBackend(data, 'sendEmail', 'planes', $formPlanesMedida);
    }

    return false;
  });

  $formCustomFeaturesButton.on('click', function (event) {
    event.preventDefault();
    var $formCustomFeatures = $(this).closest('form');

    if (validateForm($formCustomFeatures)) {
      $formCustomFeatures.addClass('disabled');
      var arrayCustomfeatures = [];
      $formCustomFeatures
        .find('.dp-exclusive-features-list input:checked')
        .each(function () {
          arrayCustomfeatures.push($(this).attr('name'));
        });

      var data = {
        nombre: $formCustomFeatures.find('#name-input').val(),
        apellido: $formCustomFeatures.find('#lastname-input').val(),
        email: $formCustomFeatures.find('#email-input').val(),
        telefono:
          $formCustomFeatures.find('.selected-dial-code').text() +
          $formCustomFeatures.find('#phone-input').val(),
        horario: $formCustomFeatures.find('#time-input').val(),
        // volumen: $formCustomFeatures.find('.options input:checked').attr('data-value'),
        volumen_envios: $formCustomFeatures
          .find('input[name=shipping]:checked')
          .attr('data-value'),
        caracteristicas: arrayCustomfeatures.toString(),
        comentarios: $('#others').is(':checked')
          ? $('#suggestion-comments').val()
          : '',
        acepto_politicas: $formCustomFeatures
          .find('input[name=acepto_politicas]')
          .is(':checked'),
      };
      sentDataBackend(data, 'sendEmail', 'planes', $formCustomFeatures);
    }
    return false;
  });

  $formSuggestionsButton.on('click', function (event) {
    event.preventDefault();
    if (validateForm($formSuggestions)) {
      var data = {
        origin: 'integraciones-sugerencias-doppler',
        email: $formSuggestions.find('input[name=email-input]').val(),
        message: $formSuggestions.find('input[name=suggestions-input]').val(),
        acepto_politicas: $formSuggestions
          .find('input[name=acepto_politicas_suggestions]')
          .is(':checked'),
        acepto_promociones: $formSuggestions
          .find('input[name=acepto_promociones_suggestions]')
          .is(':checked'),
      };
      $formSuggestions.addClass('disabled');
      sentDataBackend(
        data,
        'sendEmail',
        'Integraciones - Sugerencias',
        $formSuggestions,
      );
    }

    return false;
  });

  $formAgreementAuthButton.on('click', function (e) {
    e.preventDefault();
    if (validateForm($formAgreementAuth)) {
      $formAgreementAuth.addClass('disabled');
      $formAgreementAuth.submit();
    }

    return false;
  });

  $formAgreementButton.on('click', function (e) {
    if (validateForm($formAgreement)) {
      $formAgreement.addClass('disabled');

      //fix fullPhone fax
      var dialCode = $formAgreement.find('.iti__selected-dial-code').html();

      var fullPhone =
        dialCode + ' ' + $formAgreement.find('input[name=phone-input]').val();
      $formAgreement.find('#full-phone-input').val(fullPhone);

      var fullFax =
        dialCode + ' ' + $formAgreement.find('input[name=fax-input]').val();
      $formAgreement.find('#full-fax-input').val(fullFax);

      var data = {
        companyOwner: $formAgreement
          .find('input[name=company-owner-input]')
          .val(),
        ownerRole: $formAgreement.find('input[name=owner-role-input]').val(),
        entityName: $formAgreement.find('input[name=entity-name-input]').val(),
        entityAddress: $formAgreement
          .find('input[name=entity-address-input]')
          .val(),
        phone: fullPhone,
        fax: fullFax,
        email: $formAgreement.find('input[name=email-input]').val(),
        comment: $formAgreement.find('textarea[name=comment-input]').val(),
      };

      sentDataBackend(data, 'sendEmail', 'form-agreement', $formAgreement);
      $formAgreement.submit();
    }

    return false;
  });

  $showDownloadButton.on('click', function (e) {
    e.preventDefault();
    var hash = this.hash,
      dataHref = $(this).attr('data-href');

    if (hash != '') {
      var height = $(hash).offset().top - 74;
      location = hash;
      if (document.location.hash === hash) {
        e.preventDefault();
        $(window).scrollTop(height);
      }
    }

    if (!!readCookie('esubscriber')) {
      var $form = $(this).parent().parent().find('form'),
        action = $form.find('a.action-link')[0],
        email = readCookie('esubscriber'),
        aceptoPoliticas = readCookie('acepto_politicas'),
        aceptoPromociones = readCookie('acepto_promociones'),
        data = {
          email: email,
          list_id: $form.attr('data-list-id'),
          acepto_politicas: aceptoPoliticas,
          acepto_promociones: aceptoPromociones,
        };

      sentDataBackend(data, 'subscriber', 'resources', $form);
      setFunctionalityCookies(email, aceptoPoliticas, aceptoPromociones);

      $form
        .closest('figure')
        .addClass('downloading')
        .delay(2000)
        .queue(function () {
          $(this).removeClass('downloading').dequeue();
        });

      if (dataHref != '#') {
        $(this).attr('href', dataHref);
        simulateClick(action);
        $(this).attr('href', '');
      } else {
        simulateClick(action);
      }
    } else {
      var email = getURLParam('email'),
        $figure = $(this).closest('figure'),
        $emailInput = $figure.find('input[type=email]');

      $('figure.open').removeClass('open');
      $emailInput.val(email);
      $figure.addClass('open');
    }
  });

  $modalVideoButton.on('click', function (e) {
    e.preventDefault();
    var hash = this.hash,
      dataHref = $(this).attr('data-href');
    let $activeCookies = true;

    if (
      typeof OnetrustActiveGroups != 'undefined' &&
      (!OnetrustActiveGroups.includes('C0003') ||
        !OnetrustActiveGroups.includes('C0004'))
    ) {
      // Functional and targeting and  Cookies
      $activeCookies = false;
    }

    if (!!readCookie('esubscriber') && $activeCookies) {
      var $form = $(this).parent().parent().find('form'),
        action = $form.find('a.action-link')[0],
        email = readCookie('esubscriber'),
        aceptoPoliticas = readCookie('acepto_politicas'),
        aceptoPromociones = readCookie('acepto_promociones'),
        data = {
          email: email,
          list_id: $form.attr('data-list-id'),
          acepto_politicas: aceptoPoliticas,
          acepto_promociones: aceptoPromociones,
        },
        url = $(this).attr('data-video');

      sentDataBackend(data, 'subscriber', 'resources', $form);
      setFunctionalityCookies(email, aceptoPoliticas, aceptoPromociones);

      playModalVideo(url);
      $('body').addClass('show-modal');
      return false;
    } else {
      var email = getURLParam('email'),
        $figure = $(this).closest('figure'),
        $emailInput = $figure.find('input[type=email]');

      $('figure.open').removeClass('open');
      $emailInput.val(email);
      $figure.addClass('open');
    }
  });

  $modalVideoImageButton.on('click', function (e) {
    e.preventDefault();
    var hash = this.hash,
      dataHref = $(this).attr('data-href');

    if (!!readCookie('esubscriber')) {
      var $form = $(this).parent().parent().find('form'),
        action = $form.find('a.action-link')[0],
        email = readCookie('esubscriber'),
        aceptoPoliticas = readCookie('acepto_politicas'),
        aceptoPromociones = readCookie('acepto_promociones'),
        data = {
          email: email,
          list_id: $form.attr('data-list-id'),
          acepto_politicas: aceptoPoliticas,
          acepto_promociones: aceptoPromociones,
        },
        url = $(this).parent().find('.video').attr('data-video');

      sentDataBackend(data, 'subscriber', 'resources', $form);
      setFunctionalityCookies(email, aceptoPoliticas, aceptoPromociones);

      playModalVideo(url);
      $('body').addClass('show-modal');
      return false;
    } else {
      var email = getURLParam('email'),
        $figure = $(this).closest('figure'),
        $emailInput = $figure.find('input[type=email]');

      $('figure.open').removeClass('open');
      $emailInput.val(email);
      $figure.addClass('open');
    }
  });

  function playModalVideo(url) {
    var $iframe = $('<iframe/>', {
      type: 'video',
      src: url + '?autoplay=1&modestbranding=1&rel=0&showinfo=0',
      frameborder: '0',
    });

    $modal.append($iframe);
  }

  $('.show-hide').on('click', function (e) {
    e.preventDefault();
    var inputPass = $(this).closest('.holder').find('.password-input'),
      content = $('span.content-eye');

    if (inputPass.attr('type') == 'password') {
      inputPass.attr('type', 'text');
      content.text(content.attr('data-hide'));
      $(this).removeClass('ms-icon icon-view').addClass('ms-icon icon-hide');
    } else {
      inputPass.attr('type', 'password');
      content.text(content.attr('data-show'));
      $(this).removeClass('ms-icon icon-hide').addClass('ms-icon icon-view');
    }
  });

  function sentDataBackend(data, action, from_form, $form) {
    //action: subcsriber, sendEmail or full
    jQuery.ajax({
      type: 'POST',
      url: $('#url_home').val() + '/wp-admin/admin-ajax.php',
      data: {
        data: data,
        from_form: from_form,
        action: 'submits_backend',
      },
      success: function (response) {
        if (action == 'subscriber' || action == 'full') {
          $form.removeClass('disabled');

          if (from_form !== 'resources') {
            $form.addClass('success');
            setTimeout(function () {
              if (from_form === 'captador') {
                $captador.hide();
              } else {
                $form.removeClass('success');
              }
            }, 8000);
          }
        }
        if (action == 'sendEmail' || action == 'full') {
          if (from_form !== 'integration') {
            $form.removeClass('disabled');
            $form.addClass('success');
            clearForm($form);

            setTimeout(function () {
              $form.removeClass('success');
            }, 8000);
          }
        }
      },
    });
  }

  function validateForm(form) {
    $('input, textarea', form).each(function () {
      validateField($(this));
    });

    return form.find('.error').length === 0 ? true : false;
  }

  function clearForm(form) {
    $('input:not(.button,[type="checkbox"]), textarea', form).val('');
    form.find('input:checkbox').removeAttr('checked');
  }

  function simulateClick(link) {
    var evt = document.createEvent('MouseEvents');

    evt.initMouseEvent(
      'click',
      true,
      true,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null,
    );
    link.dispatchEvent(evt);
  }

  function getURLParam(prop) {
    var params = {},
      search = location.search.split('?')[1],
      definitions = !!search ? search.split('&') : [];

    definitions.forEach(function (val, key) {
      var parts = val.split('=', 2);
      params[parts[0]] = parts[1];
    });

    return prop && prop in params ? params[prop] : '';
  }

  function validateField(field) {
    var emailRegex = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
    ),
      urlRegex = new RegExp(
        /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi,
      ),
      numberRegex = new RegExp('^[0-9]+$'),
      val = field.val(),
      lang = document.documentElement.lang.substring(0, 2),
      messageRequired_es = '¡Ouch! El campo está vacío.',
      messageRequired_en = 'Ouch! The field is empty.',
      messageEmail_es = '¡Ouch! Ingresa un Email válido.',
      messageEmail_en = 'Ouch! Enter a valid Email.',
      messageURL_es = '¡Ouch! Ingresa una URL válida.',
      messageURL_en = 'Ouch! Enter a valid URL.',
      messageNumber_es = '¡Ouch! Ingresa un número válido.',
      messageNumber_en = 'Ouch! Enter a valid number.',
      $parent = field.closest('.holder');

    if (!val && field.hasClass('required')) {
      $parent.addClass('error');

      if (lang == 'en') {
        $parent.attr('data-error', messageRequired_en);
      } else if (lang == 'es') {
        $parent.attr('data-error', messageRequired_es);
      }
    } else if (
      field.hasClass('check') &&
      field.hasClass('required') &&
      !field.is(':checked')
    ) {
      $parent.addClass('error');

      if (lang == 'en') {
        $parent.attr('data-error', messageRequired_en);
      } else if (lang == 'es') {
        $parent.attr('data-error', messageRequired_es);
      }
    } else if (field.hasClass('email') && !val.match(emailRegex)) {
      $parent.addClass('error');

      if (lang == 'en') {
        $parent.attr('data-error', messageEmail_en);
      } else if (lang == 'es') {
        $parent.attr('data-error', messageEmail_es);
      }
    } else if (field.hasClass('url') && !val.match(urlRegex)) {
      $parent.addClass('error');

      if (lang == 'en') {
        $parent.attr('data-error', messageURL_en);
      } else if (lang == 'es') {
        $parent.attr('data-error', messageURL_es);
      }
    } else if (field.hasClass('number') && !val.match(numberRegex)) {
      $parent.addClass('error');

      if (lang == 'en') {
        $parent.attr('data-error', messageNumber_en);
      } else if (lang == 'es') {
        $parent.attr('data-error', messageNumber_es);
      }
    } else if (!field.is(':hidden') && !field.hasClass('phone-number')) {
      $parent.removeClass('error');
    }
  }

  function setFunctionalityCookies(
    email,
    acepto_politicas,
    acepto_promociones,
  ) {
    if (
      typeof OnetrustActiveGroups != 'undefined' &&
      OnetrustActiveGroups.includes('C0003')
    ) {
      // Functional Cookies
      setCookie('esubscriber', email, 100000);
      setCookie('acepto_promociones', acepto_promociones, 100000);
    }

    if (
      typeof OnetrustActiveGroups != 'undefined' &&
      OnetrustActiveGroups.includes('C0001')
    ) {
      // Strictly neccesary cookies
      setCookie('acepto_politicas', acepto_politicas, 100000);
    }
  }
});
